const INPUT_OPTIONS = {
    brand_id: {
        fieldId: 2364367
    },
    ticket_form_id: {
        fieldId: 360000033656
    },
    orderNumber: {
        fieldId: 360000128175
    },
    preferContactMethod: {
        fieldId: 360000208655
    },
    FirstName: {
        fieldId: 80635907
    },
    LastName: {
        fieldId: 80635927
    },
    Contact: {
        fieldId: 67323707
    }
};
module.exports = INPUT_OPTIONS;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/rescheduledelivery/rescheduledelivery-setup.js
 **/